import { useCallback } from 'react';
import { Channel, useAppBridge, useChannelContext, useWebviewBridge } from 'scbk-services';
import useGlobalComponentsStore from '../stores/useGlobalComponentsStore';

const useLoading = () => {
  const store = useGlobalComponentsStore();
  const { channel } = useChannelContext();
  const { doNOpenProgressDlg, doNCloseProgressDlg } = useAppBridge();
  const { doNGetCurrentWebviewStatus } = useWebviewBridge();

  const showLoading = useCallback(async () => {
    //모바일뱅킹
    if (channel === Channel.MB) {
      const { isTop } = await doNGetCurrentWebviewStatus();
      if (!isTop) {
        return;
      }

      await doNOpenProgressDlg();
      //모바일뱅킹 외 채널
    } else {
      store.setLoading(true);
    }
  }, [channel, doNOpenProgressDlg]);

  const hideLoading = useCallback(async () => {
    //모바일뱅킹
    if (channel === Channel.MB) {
      const { isTop } = await doNGetCurrentWebviewStatus();
      if (!isTop) {
        return;
      }

      doNCloseProgressDlg();
      //모바일뱅킹 외 채널
    } else {
      store.setLoading(false);
    }
  }, [channel, doNOpenProgressDlg]);

  return {
    show: showLoading,
    hide: hideLoading,
  };
};

export default useLoading;
